<template>
	<div>
		<div class="box">
			<my-iconTextNav></my-iconTextNav>
			<img src="../assets/img/logPic.png" class="logPic">
			<div class="inputArea">
				<div class="item">
					<div class="title">手机号</div>
					<div class="inputBox">
						<input type="text" v-model="tel">
						<span class="warn" v-if='!tel && showWarnTel'>请输入手机号</span>
					</div>
				</div>
				<div class="item">
					<button class="getCode" @click="getCode">{{getCodeToast}}</button>
				</div>
				<!-- 极验拖动认证 -->
				<div class="item">
					<div id="geetest" style="float: right;"></div>
					<div style="clear: both;"></div>
				</div>
				<div class="item">
					<div class="title">短信验证码</div>
					<div class="inputBox">
						<input type="text" v-model="code">
						<span class="warn" v-if='!code && showWarnCode'>请输入验证码</span>
					</div>
				</div>
				<div class="item">
					<div class="title">密码</div>
					<div class="inputBox">
						<input type="text" v-model="pwd">
						<span class="warn" v-if='!pwd && showWarnPwd'>请输入密码</span>
					</div>
				</div>
				<div class="item">
					<div class="registerBtn" @click='commit'>提交</div>
				</div>
			</div>
			<div style="clear: both;"></div>
		</div>
		
		<one-lineFooter></one-lineFooter>
	</div>
</template>

<script>
	export default {
		name: 'forgetPwd',
		data() {
			return {
				tel: '',
				code: '',
				pwd: '',
				showWarnTel: false,
				showWarnCode: false,
				showWarnPwd: false,
				getCodeToast:'免费获取短信验证码',
				geeTestInfo:{}, //极验认证前端生成的密钥
				captchaObj:null //极验认证对象
			}
		},
		methods: {
			check: function() {
				var t = true;
				if (!this.tel) {
					t = false;
					this.showWarnTel = true;
				}
				if (!this.code) {
					t = false;
					this.showWarnCode = true;
				}
				if (!this.pwd) {
					t = false;
					this.showWarnPwd = true;
				}
				return t;
			},
			getCode: function() {
				var that = this;
				if (!that.tel) {
					that.$message.error('请输入手机号')
					that.showWarnTel = true;
					return;
				}
				if(!that.geeTestInfo.geetest_challenge){
					that.$message.error('请先完成验证')
					return;
				}
				if(that.getCodeToast != '免费获取短信验证码'){
					that.$message.error('请在短信倒计时结束后再点击');
					return;
				}
				
				that.axios.post('/resUrl/api/Login/verify', {
						mobile: that.tel,
						challenge: that.geeTestInfo.geetest_challenge,
						validate: that.geeTestInfo.geetest_validate,
						seccode: that.geeTestInfo.geetest_seccode
					})
					.then(function(res) {
						if (res.data.code == 0) {
							//倒计时
							var s = 60;
							setInterval(that.getCodeTime);
							that.getCodeTime = setInterval(()=>{
								s--;
								if( s == 0){
									that.getCodeToast = `免费获取短信验证码`;
									that.geeTestInfo = {};
									that.captchaObj.reset(); 
									clearTimeout(that.getCodeTime)
									return;
								}
								that.getCodeToast = `还剩${s}秒`;
							},1000)
						}
					})
					.catch(function() {
						that.$message.error('连接超时')
					});
			},
			commit: function() {
				var that = this;
				if (that.check()) {
					that.axios.post('/resUrl/api/Login/findPassword', {
							mobile: that.tel,
							password: that.pwd,
							code: that.code,
							group_id: that.$store.state.group_id
						})
						.then(function(res) {
							if (res.data.code == 0) {
								var result = res.data.content;
								that.$store.commit('updateUserInfo',{
									token: result.token,
									avatar: result.avatar?that.$store.state.resUrl + result.avatar:require('@/assets/img/default-avatar.png'),
									nickname: result.nickname?result.nickname:'聚客电影用户'
								})
								
								that.$router.replace('/');
							} else {
								that.geeTestInfo = {};
								that.captchaObj.reset(); 
							}
						})
				}

			},
			iniGeeTest: function() {
				var that = this;
				that.axios.post('/resUrl/api/login/verifyInit', {
						type: 'h5',
						group_id: that.$store.state.group_id
					})
					.then(function(res) {
						if (res.data.code == 0) {
							var result = res.data.content;
							initGeetest({
								// 以下配置参数来自服务端 SDK
								product: 'float',
								gt: result.gt,
								challenge: result.challenge,
								offline: !result.success,
								new_captcha: true
							}, function(captchaObj) {
								captchaObj.appendTo('#geetest');
								that.captchaObj = captchaObj;
								// 这里调用了 onSuccess 方法，该方法介绍见下文
								captchaObj.onSuccess(function () {
									var result = captchaObj.getValidate();
									that.sucVerGeeTest = true;
									that.geeTestInfo = result;
								});
							})
						} 
					})
			}
		},
		created: function() {
			//初始化极验
			this.iniGeeTest();
		}
	}
</script>

<style scoped src='@/assets/css/forgetPwd.css'>
</style>
